import React, {useState, useEffect} from 'react';

// import io from "socket.io-client";

import './ScoreBoard.scss'

function ScoreBoard({subdomain}) {

    subdomain = subdomain || 'codetrack';

    const [scoreboard, setScoreboard ] = useState({});
    // const [socket, setSocket] = useState(null);

    useEffect(() => {

        const url = `${process.env.REACT_APP_API}/scoreboard/${subdomain}`;
        fetch(url)
        .then(res => res.json())
        .then((result) => {
            setScoreboard(result);
        },
         
          (error) => {
            console.log(error);
          }
        )
    }, []);

    // useEffect(() => {
    //     const clientSocket = io('https://codewars-tracker-be.herokuapp.com/');

    //     clientSocket.on("codewars_points_scored", (updatedScores) => { 
    //         setScoreboard(updatedScores)
    //     });
    
    //     setSocket(clientSocket);
    // }, [])

    return (
        <div className="scoreBoard">
            <div className="scoreBoard__title">Score <br/> Board</div>
 
            <div className="scoreBoard__week">
                <div className="scoreBoard__subtitle"> Weekly </div>
                { subdomain != 'codetrack' && <>
                    <div>
                        <span>Fellows: </span> {scoreboard.fellows_this_week} 
                    </div>
                    <div>
                        <span>Staff: </span> {scoreboard.staff_this_week} 
                    </div>
                </> }

                { subdomain == 'codetrack' &&
                    <div className='scoreBoard__singleScore'>
                        <span>Coders: </span> {scoreboard.fellows_this_week} 
                    </div>
                }
            </div>

            <div className="scoreBoard__month">
                <div className="scoreBoard__subtitle"> Monthly </div>
                { subdomain != 'codetrack' && <>
                    <div>
                        <span>Fellows: </span> {scoreboard.fellows_this_month} 
                    </div>
                    <div>
                        <span>Staff: </span> {scoreboard.staff_this_month} 
                    </div>
                </> }
                { subdomain == 'codetrack' &&
                    <div className='scoreBoard__singleScore'>
                        <span>Coders: </span> {scoreboard.fellows_this_month}  
                    </div>
                }
            </div>

            <div className="scoreBoard__allTime">
                <div className="scoreBoard__subtitle"> All Time </div>
                { subdomain != 'codetrack' && <>
                    <div>
                        <span>Fellows: </span>{scoreboard.fellows_all_time} 
                    </div>
                    <div>
                        <span>Staff: </span> {scoreboard.staff_all_time} 
                    </div>
                </> }
                { subdomain == 'codetrack' &&
                    <div className='scoreBoard__singleScore'>
                        <span>Coders: </span> {scoreboard.fellows_all_time} 
                    </div>
                }
            </div>
        </div>
    );
}

export default ScoreBoard;